const INITIAL_STATE = {
    modelos: { data: [] },
    modelosSelect: [],
    modeloVeiculo: null
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'MODELOS_FETCH':
            return { ...state, modelos: action.payload }
        case 'MODELOS_SELECT_FETCH':
            return { ...state, modelosSelect: action.payload }
        case 'MODELO_SET':
            return { ...state, modelo: action.payload }
        default:
            return state
    }
}